/**
 * @typedef {import('./lib/index.js').CharacterReferences} CharacterReferences
 * @typedef {import('./lib/index.js').Options} Options
 * @typedef {import('./lib/index.js').Quote} Quote
 * @typedef {import('./lib/index.js').Space} Space
 */

export {toHtml} from './lib/index.js'
